import { Button } from 'flowbite-react';
import { Link } from 'react-router-dom';
import PayrollModal from './Payroll/PayrollModal';
import { useState } from 'react';

export default function Settings() {
  const [showPayroll, setshowPayroll] = useState<boolean>(false);

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1'>
            <div className='mb-4'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Admin</div>
              </h1>
              <hr></hr>
            </div>
            <div className='gap-5 flex flex-col'>
              <fieldset className='border p-3'>
                <legend className='text-2xl'>Settings</legend>
                <div className='pt-4 flex gap-3'>
                  <div>
                    <Link to={'/admin/settings/deliverycompleteemail'}>
                      <Button type='button' className='buttonMain'>
                        Delivery Complete Email Setup
                      </Button>
                    </Link>
                  </div>
                  <div>
                    <Link to={'/admin/timesheet'}>
                      <Button type='button' className='buttonMain'>
                        Timesheet Admin
                      </Button>
                    </Link>
                  </div>
                </div>
              </fieldset>
              <fieldset className='border p-3'>
                <legend className='text-2xl'>Reports</legend>
                <div className='pt-4 flex gap-3'>
                  <div>
                    <Button
                      type='button'
                      onClick={() => setshowPayroll(true)}
                      className='buttonMain'
                    >
                      Payroll
                    </Button>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      <PayrollModal show={showPayroll} setShow={setshowPayroll} />
    </>
  );
}
